/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Notifications_DescriptionInputs */

const he_hero_notifications_description = /** @type {(inputs: Hero_Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדירו התראה על כל מוצר וקבלו עדכון כשהמחיר יורד או שהמוצר חוזר למלאי.`)
};

const en_hero_notifications_description = /** @type {(inputs: Hero_Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set alerts on any product and get notified when the price drops or it's back in stock.`)
};

/**
* | output |
* | --- |
* | "Set alerts on any product and get notified when the price drops or it's back in stock." |
*
* @param {Hero_Notifications_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_notifications_description = /** @type {((inputs?: Hero_Notifications_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Notifications_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_notifications_description(inputs)
	return en_hero_notifications_description(inputs)
});